import { apiConstants, getWork } from "../config";
const req = require.context("../../interventions/", true, /state.js$/);
const modules = req.keys().map(req);
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

let state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        configs: {
            uploadFiles: {
                maxFiles: 10,
                mimeTypes: [
                    "application/msword",
                    "application/vnd.ms-excel",
                    "application/vnd.ms-powerpoint",
                    "application/pdf",
                    "image/x-png",
                    "image/jpeg",
                ],
            },
        },
        panels: {
            home_manage: {
                menu: {
                    route: `${code}.home`,
                    text: "home.title_manage",
                    icon: "fas fa-home",
                },
                acl: {
                    view: "GIM_20000",
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: "settings.titles",
                    icon: "fas fa-cogs",
                },
                acl: {
                    view: "GIM_20051",
                    edit: "GIM_20052",
                },
                url: {
                    getConfig: `/${codeAPI}/gestao/definitions`,
                },
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: 'default_layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view: 'GIM_20005',
                    detail: 'GIM_20006',
                    add: 'GIM_20007',
                    edit: 'GIM_20008',
                    delete: 'GIM_20009',
                },
                url: {
                    getList: `${codeAPI}/gestao/defaultlayers`,
                    getShow: `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate: `${codeAPI}/gestao/defaultlayers`,
                    getUpdate: `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete: `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists: `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources: `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: "layers.titles",
                    icon: "fas fa-layer-group",
                },
                acl: {
                    view: "GIM_20031",
                    detail: "GIM_20032",
                    add: "GIM_20033",
                    edit: "GIM_20034",
                    delete: "GIM_20035",
                    private: "GIM_20033",
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                },
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: "print_visible_emissions.title",
                    icon: "fas fa-print",
                },
                acl: {
                    view: "GIM_20041",
                    config: "GIM_20041",
                    configEdit: "GIM_20042",
                },
                url: {
                    getList: `/${codeAPI}/gestao/printvisible`,
                    getConfig: `/${codeAPI}/gestao/printvisible/settings`,
                    getApps: `/${codeAPI}/gestao/printvisible/print/apps`,
                },
            },
            global_statuses: {
                menu: {
                    route: `${code}.global_statuses`,
                    text: "global_statuses.titles",
                    icon: "fas fa-info-circle",
                },
                acl: {
                    view: "GIM_20011",
                    detail: "GIM_20012",
                    add: "GIM_20013",
                    edit: "GIM_20014",
                    delete: "GIM_20015",
                },
                url: {
                    getList: `/${codeAPI}/gestao/statuses`,
                    getShow: `/${codeAPI}/gestao/statuses/:id`,
                    getCreate: `/${codeAPI}/gestao/statuses`,
                    getUpdate: `/${codeAPI}/gestao/statuses/:id`,
                    getDelete: `/${codeAPI}/gestao/statuses/:id`,
                    getLists: `${codeAPI}/gestao/statuses/lists`,
                    getRelationship: `${codeAPI}/gestao/statuses/entity/:code`,
                },
            },
            global_types: {
                menu: {
                    route: `${code}.global_types`,
                    text: "global_types.titles",
                    icon: "fas fa-tasks",
                },
                acl: {
                    view: "GIM_20021",
                    detail: "GIM_20022",
                    add: "GIM_20023",
                    edit: "GIM_20024",
                    delete: "GIM_20025",
                },
                url: {
                    getList: `/${codeAPI}/gestao/types`,
                    getShow: `/${codeAPI}/gestao/types/:id`,
                    getCreate: `/${codeAPI}/gestao/types`,
                    getUpdate: `/${codeAPI}/gestao/types/:id`,
                    getDelete: `/${codeAPI}/gestao/types/:id`,
                    getLists: `${codeAPI}/gestao/types/lists`,
                    getRelationship: `${codeAPI}/gestao/types/entity/:code`,
                },
            },
        },
        tools: {

        }
    },
};

modules.forEach((module) => {
    const work = getWork(module.type);
    if (work.active === true) {
        const panels = module.panels;
        state.data.panels = {
            ...state.data.panels,
            ...panels,
        };
    }
});

export default state;
